/** Build POST body for `/api/admin/ai-config/leaves/.../delete` from selected inventory rows. */
export function buildLeafDeleteRequestBody(
  resources: Array<{
    type: string;
    name: string;
    metadata?: {
      appName?: string;
      teamName?: string;
      chatName?: string;
      channelId?: string;
      channelKind?: string;
    };
  }>,
) {
  return {
    deleteRepos: resources.filter((r) => r.type === 'repo').map((r) => r.name),
    deleteAdoProjects: resources.filter((r) => r.type === 'adoProject').map((r) => r.name),
    deleteBots: resources.filter((r) => r.type === 'bot').map((r) => r.name),
    deleteBotServices: resources.filter((r) => r.type === 'botService').map((r) => r.name),
    deleteTeamsApps: resources.filter((r) => r.type === 'teamsApp').map((r) => r.name),
    deleteTeamsTeams: resources.filter((r) => r.type === 'teamsTeam').map((r) => r.name),
    deleteTeamsChats: resources.filter((r) => r.type === 'teamsChat').map((r) => r.name),
    deleteTeamsChannels: resources
      .filter((r) => r.type === 'teamsChannel' && r.metadata?.teamName && r.metadata?.channelId)
      .map((r) => ({
        teamName: r.metadata!.teamName!,
        channelId: r.metadata!.channelId!,
        channelKind: r.metadata?.channelKind,
      })),
    deleteTeamsTeamInstalls: resources
      .filter((r) => r.type === 'teamsTeamInstall' && r.metadata?.teamName && r.metadata?.appName)
      .map((r) => ({
        teamName: r.metadata!.teamName!,
        appName: r.metadata!.appName!,
      })),
    deleteTeamsChatInstalls: resources
      .filter((r) => r.type === 'teamsChatInstall' && r.metadata?.chatName && r.metadata?.appName)
      .map((r) => ({
        chatName: r.metadata!.chatName!,
        appName: r.metadata!.appName!,
      })),
    deleteTeamsUserInstalls: resources
      .filter((r) => r.type === 'teamsUserInstall' && r.metadata?.teamName && r.metadata?.appName)
      .map((r) => ({
        teamName: r.metadata!.teamName!,
        appName: r.metadata!.appName!,
      })),
  };
}

export async function postLeafDeleteJson(
  apiBase: string,
  streamId: string,
  product: string,
  teamType: string,
  tenantCode: string,
  body: ReturnType<typeof buildLeafDeleteRequestBody>,
): Promise<void> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  const accessToken = localStorage.getItem('oci_access_token');
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
  const url = `${apiBase}/api/admin/ai-config/leaves/${encodeURIComponent(streamId)}/${encodeURIComponent(product)}/${encodeURIComponent(teamType)}/${encodeURIComponent(tenantCode)}/delete`;
  const response = await fetch(url, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const errText = await response.text();
    throw new Error(errText || 'Leaf delete failed');
  }
}
